import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { TITLE } from '../../constants';
import { Context } from './Context';
const Title = forwardRef(({ as: Element = 'h3', children, ...rest }, ref) => {
    const { id } = useContext(Context);
    return (_jsx(Element, { ref: ref, id: `${id}-title`, ...rest, children: children }));
});
Title.displayName = TITLE;
export { Title };
//# sourceMappingURL=Title.js.map